class ProductHandler {
  constructor(baseURL, basicUsername, basicPassword) {
    this.baseURL = baseURL;
    this.basicUsername = basicUsername;
    this.basicPassword = basicPassword;
  }

  getAuthorizationHeader() {
    const credentials = `${this.basicUsername}:${this.basicPassword}`;
    const base64Credentials = btoa(credentials);
    return {
      "Content-Type": "application/json",
      "Authorization": `Basic ${base64Credentials}`,
      Accepts: "application/json",
    };
  }

  async getAllProducts() {
    try {
      const response = await fetch(`${this.baseURL}/products/`, {
        method: "GET",
        headers: this.getAuthorizationHeader(),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  async getFilteredProducts(filter) {
    try {
      const response = await fetch(`${this.baseURL}/products/filter/${filter}`, {
        method: "GET",
        headers: this.getAuthorizationHeader(),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  async getProductByProductId(productId) {
    try {
      const response = await fetch(`${this.baseURL}/products/${productId}`, {
        method: "GET",
        headers: this.getAuthorizationHeader(),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  async updateProduct(productId, body) {
    try {
      const response = await fetch(`${this.baseURL}/products/${productId}`, {
        method: "PATCH",
        headers: this.getAuthorizationHeader(),
        body: JSON.stringify(body)
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }
  async getProductImagesByImageId(imageId) {
    try {
      const response = await fetch(`${this.baseURL}/product_images/${imageId}`, {
        method: "GET",
        headers: this.getAuthorizationHeader(),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

}

export default ProductHandler;
